import { getInitializer } from '@websolutespa/bom-mixer-llm';

export const bomLlm = getInitializer('bomLlm', []);
